import React, { useState } from 'react';
import { Button, Menu, MenuItem, Typography, FormControl, useMediaQuery } from "@mui/material";
import { FaChevronUp } from "react-icons/fa";
import { LuEye, LuEyeOff } from "react-icons/lu";
import '../../css/Dashboard.css';
import theme from '../../theme';

const titleStyles = {
  display: 'flex',
  fontSize: '12px',
  color: '#6E89AF',
  margin: '5px 0px 10px 0px',
  textTransform: 'uppercase',
  padding: '0px 16px 0px 16px',
  fontWeight: '600',
  fontFamily: 'roboto',
};

const labelStyles = {
  display: 'flex',
  fontSize: '15px',
  color: '#000',
  padding: '2px 0px 0px 0px',
  fontWeight: '500',
  fontFamily: 'roboto',
  textAlign: 'left',
  textTransform: 'capitalize',
};

const ViewSelector = ({ currentView, onChange, launched, windowWidth }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isMobile = windowWidth < 1280

  const handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value) => {
    setAnchorEl(null);
    if (value) {
      onChange({ target: { value } });
    }
  };

  // let viewLabel = "Member";
  let viewLabel = isMobile ? "Member" : "Creator";
  if (currentView === "user-waitlist") {
    viewLabel = "Waitlist";
  } else if (currentView === "user") {
    viewLabel = "Non-member";
  } else if (currentView === "user-subscribed") {
    viewLabel = "Member";
  }

  const renderMenuItem = (value, label, description) => (
    <MenuItem onClick={() => handleClose(value)} selected={currentView === value}
      sx={{
        '&:hover': {
          backgroundColor: '#F6F7FF',
        },
        '&.Mui-selected': {
          backgroundColor: '#F6F7FF',
          color: '#222222',
        },
        '&.Mui-selected:hover': {
          backgroundColor: '#F6F7FF',
        }

      }}>
      <div style={{ display: 'flex', flexDirection: 'column', fontWeight: '500', color: '#222222', cursor: 'pointer', fontSize: '14px', fontFamily: 'roboto', padding: '2px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontFamily: 'roboto', fontWeight: '500' }}>{label}</span> {currentView === value ? <LuEye style={{ fontSize: '15px', marginRight: '10px', color: 'var(--brand-color)', paddingLeft: '5px' }} /> :
            //   <LuEyeOff style={{ fontSize: '12px', marginRight: '10px', color: '#757575' }} />
            null
          }
        </div>
        <p style={{ fontSize: '12px', margin: '0px', color: '#6E89AF', fontFamily: 'roboto' }}>{description}</p>
      </div>
    </MenuItem>
  );

  return (
    <div className="view-selector" style={{ bottom: '20px', border: 'none', outline: 'none' }}>
      <FormControl style={{ border: 'none', fontSize: '15px', width: windowWidth < 600 ? 'calc(100% - 50px)' : '100%', minWidth: windowWidth < 600 ? '' : '180px', outline: 'none', textAlign: 'left', }}>
        <Button
          onClick={handleClick}
          endIcon={<FaChevronUp style={{ fontSize: '12px', color: '#757575', marginRight: '5px' }} />}
          fullWidth
          sx={{
            cursor: 'pointer',
            height: '35px',
            fontSize: '15px',
            backgroundColor: 'white',
            borderRadius: '8px',
            width: '100%',
            border: '1px solid #DFDFDF',
            boxShadow: 'none',
            paddingLeft: '5px',
            textAlign: 'left',
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: 'white',
              border: '1px solid #C4C4C4',
            }
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LuEye style={{ fontSize: '16px', margin: '0px 5px 0px 5px', color: '#222222' }} />
            <Typography variant="body2" style={labelStyles}>{viewLabel}</Typography>
          </div>
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          sx={{
            margin: isMobile ? '0px 0px 20px 0px' : '30px -10px 20px 0px', padding: '0px', borderRadius: '8px', '&:selected': {
              backgroundColor: '#fff',
            }
          }}
          onClose={() => handleClose(null)}
          PaperProps={{
            style: {
              width: '300px',
              border: '1px solid #DFDFDF',
              borderRadius: '8px',
              padding: '0px',
              boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',

            },
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
        >
          <p style={titleStyles}>
            Select View
          </p>
          {/* {!isMobile && renderMenuItem("creator", "Creator", "View the platform as yourself")} */}
          {launched === false && renderMenuItem("user-waitlist", "Waitlist", "View the platform as a waitlist user")}
          {renderMenuItem("user", "Non-Member", "View the platform as a Non-member")}
          {renderMenuItem("user-subscribed", "Member", "View the platform as a Member")}
        </Menu>
      </FormControl>
    </div>
  );
};

export default ViewSelector;
